import AppLogInfoStore from './audits/state/AppLogInfoStore';
import AppLogListStore from './audits/state/AppLogListStore';
import SystemLogInfoStore from './audits/state/SystemLogInfoStore';
import SystemLogListStore from './audits/state/SystemLogListStore';
import TimbradoRetencionInfoStore from './stamping/state/TimbradoRetencionInfoStore';
import TimbradoRetencionListStore from './stamping/state/TimbradoRetencionListStore';
import TimbradoComprobanteInfoStore from './stamping/state/TimbradoComprobanteInfoStore';
import TimbradoComprobanteListStore from './stamping/state/TimbradoComprobanteListStore';

const DeveloperStore = {
  audits: {
    applog: AppLogInfoStore,
    applogs: AppLogListStore,
    systemlog: SystemLogInfoStore,
    systemlogs: SystemLogListStore,
  },
  stamping: {
    comprobante: TimbradoComprobanteInfoStore,
    comprobantes: TimbradoComprobanteListStore,
    retencion: TimbradoRetencionInfoStore,
    retenciones: TimbradoRetencionListStore,
  },
};

export default DeveloperStore;
